import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from 'reduxStore/types';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
